module.exports = __webpack_public_path__ + "static/media/meeting-jane-colored.646c2844.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/meeting-jane-colored.png
// module id = 1889
// module chunks = 0